<template>
  <v-stepper-header class="elevation-0 px-4" v-if="(!isLastMovementEntry || isRecepcionar) && !isAssignment && !isMovement">
    <v-stepper-step :complete="currentStep > 1" step="1" color="primary">
      Transporte
    </v-stepper-step>
    <v-divider></v-divider>
    <v-stepper-step :complete="currentStep > 2" step="2" color="primary">
      Vehículo
    </v-stepper-step>
    <v-divider></v-divider>
    <v-stepper-step step="3" color="primary">
      Equipo
    </v-stepper-step>
  </v-stepper-header>
</template>

<script>

export default {
  name: 'StepperHeader',
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    isLastMovementEntry: {
      type: Boolean,
      required: true
    },
    isRecepcionar: {
      type: Boolean,
      required: true
    },
    isAssignment: {
      type: Boolean,
      required: false
    },
    isMovement: {
      type: Boolean,
      required: false
    }
}
}
</script>
